import $ from 'jquery';
import select2Factory from 'select2/dist/js/select2.js';
import 'select2/dist/css/select2.css';

if (typeof window !== 'undefined') {
  window.jQuery = window.$ = $;
}

let registered = false;

export function ensureSelect2(jq = $) {
  if (typeof jq.fn.select2 === 'function') {
    registered = true;
    return jq;
  }
  if (!registered) {
    select2Factory(window, jq);
    registered = typeof jq.fn.select2 === 'function';
  }
  return jq;
}

ensureSelect2();

export default $;
